import animatedScroll from 'animated-scroll-to';

const scrollConfig = {
  maxDuration: 1500
};

export default el => {
  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop >= 500 && !el.classList.contains('bottombar--visible')) {
      el.classList.add('bottombar--visible');
    } else if(scrollTop <= 500 && el.classList.contains('bottombar--visible')) {
      el.classList.remove('bottombar--visible');
    }
  };

  const onClick = () => {
    animatedScroll(0, scrollConfig);
  };

  document.addEventListener('scroll', onScroll);
  el.addEventListener('click', onClick)
}
